enum DataLoadingStatusEnum {
  NOT_INITIALIZED = "NOT_INITIALIZED",
  NOT_LOADED = "NOT_LOADED",
  LOADING = "LOADING",
  LOADED = "LOADED",
}

export default DataLoadingStatusEnum;
